import {
    GET_IS_MOBILE_GRAPHIC_SHOWN,
    SET_SHOW_MOBILE_GRAPHIC,
    SET_HIDE_MOBILE_GRAPHIC,
    GET_IMAGE_SRC,
    SET_IMAGE_SRC,
    GET_SHOW_ZOOMED_MODAL,
    TOGGLE_ZOOM_MODAL,
    IS_MOBILE,
    SET_IS_MOBILE
} from "../actions/profile";

const state = {
    profile: {
        isMobileDamGraphicShown: false,
        isZoomModalShown: false,
        imgSrc: "",
        isMobile: null
    }
};

const getters = {
    [IS_MOBILE]: (state) => state.profile.isMobile,
    [GET_IS_MOBILE_GRAPHIC_SHOWN]: (state) => state.profile.isMobileDamGraphicShown,
    [GET_SHOW_ZOOMED_MODAL]: state => state.profile.isZoomModalShown,
    [GET_IMAGE_SRC]: state => state.profile.imgSrc
};

const actions = {
    [SET_SHOW_MOBILE_GRAPHIC]: ({ commit }) => commit(SET_SHOW_MOBILE_GRAPHIC),
    [SET_HIDE_MOBILE_GRAPHIC]: ({ commit }) => commit(SET_HIDE_MOBILE_GRAPHIC),
    [TOGGLE_ZOOM_MODAL]: ({commit}) => commit(TOGGLE_ZOOM_MODAL),
    [SET_IMAGE_SRC]: ({commit}, src) => commit(SET_IMAGE_SRC, src),
    [SET_IS_MOBILE]: ({commit}, flag) => commit(SET_IS_MOBILE, flag)
};

const mutations = {
    [SET_SHOW_MOBILE_GRAPHIC]: (state) => {
        state.profile.isMobileDamGraphicShown = true;
    },
    [SET_HIDE_MOBILE_GRAPHIC]: (state) => {
        state.profile.isMobileDamGraphicShown = false;
    },
    [TOGGLE_ZOOM_MODAL]: (state) => {
        return state.profile.isZoomModalShown = !state.profile.isZoomModalShown;
    },
    [SET_IMAGE_SRC]: (state, src) => {
        return state.profile.imgSrc = src;
    },
    [SET_IS_MOBILE]: (state, flag) => {
        return state.profile.isMobile = flag;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};

